var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherDop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 211,
    viewBox: "0 0 178 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.955078 169.658V169.737H9.33984V169.619C9.33984 163.686 14.0464 159.177 20.2954 159.177C26.228 159.177 30.8159 163.211 30.8159 168.274C30.8159 172.743 28.9966 175.749 22.0356 182.987L1.42969 203.988V210H40.4663V202.525H13.374V202.327L27.6519 187.97C35.9971 179.427 39.5566 174.483 39.5566 167.839C39.5566 158.782 31.4487 151.86 20.5723 151.86C9.22119 151.86 0.955078 159.375 0.955078 169.658Z",
    fill: "#000314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1514 210H83.6548V198.728H91.4858V191.292H83.6548V152.928H70.8403C57.9863 171.517 51.5 181.761 46.5957 190.976V198.728H75.1514V210ZM54.8618 191.213C59.4102 182.947 65.1846 174.048 75.0723 159.771H75.2305V191.411H54.8618V191.213Z",
    fill: "#000314"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.204 175.868C115.769 175.868 120.95 170.687 120.95 164.121C120.95 157.556 115.769 152.375 109.204 152.375C102.638 152.375 97.4966 157.556 97.4966 164.121C97.4966 170.687 102.638 175.868 109.204 175.868ZM109.243 170.172C106 170.172 103.192 167.404 103.192 164.121C103.192 160.759 106.04 158.07 109.243 158.07C112.605 158.07 115.294 160.759 115.294 164.121C115.294 167.404 112.605 170.172 109.243 170.172Z",
    fill: "#000314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.539 210.949C166.67 210.949 175.608 204.028 177.784 192.242H168.964C167.184 199.124 161.528 203.197 153.579 203.197C143.098 203.197 136.453 194.773 136.453 181.444C136.453 168.234 143.177 159.731 153.539 159.731C161.291 159.731 167.382 164.517 168.964 171.833H177.744C176.241 159.929 166.472 151.979 153.539 151.979C137.6 151.979 127.396 163.37 127.396 181.444C127.396 199.638 137.521 210.949 153.539 210.949Z",
    fill: "#000314"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3593 131.476C36.4854 131.478 36.6131 131.476 36.7393 131.476H127.937C128.064 131.476 128.191 131.479 128.317 131.476C139.684 131.274 148.836 121.993 148.836 110.577C148.836 101.571 143.139 93.8948 135.152 90.9566L135.157 90.4376C135.157 74.2748 122.385 61.1337 106.507 60.8047C101.283 45.3359 86.6515 34.1991 69.4184 34.1991C47.802 34.1991 30.2794 51.7222 30.2794 73.338C30.2794 74.4775 30.3284 75.6055 30.4234 76.7202C18.1465 79.5789 9 90.5899 9 103.737C9 118.93 21.2146 131.273 36.3593 131.476Z",
    fill: "#4181FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120.717,
    width: 9.87973,
    height: 13.6796,
    rx: 4.93987,
    fill: "#FFCD1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176.814,
    y: 45.4572,
    width: 9.87973,
    height: 14.4396,
    rx: 4.93987,
    transform: "rotate(90 176.814 45.4572)",
    fill: "#FFCD1D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.1191,
    y: 17.9863,
    width: 9.87973,
    height: 12.0621,
    rx: 4.93987,
    transform: "rotate(-45 86.1191 17.9863)",
    fill: "#FFCD1D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.87973,
    height: 12.0318,
    rx: 4.93987,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 164.908 17.9893)",
    fill: "#FFCD1D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9.87973,
    height: 12.0318,
    rx: 4.93987,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 158.104 89.2119)",
    fill: "#FFCD1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.961 71.8533C149.236 66.6962 153.238 58.8751 153.238 50.1192C153.238 34.5894 140.648 22 125.118 22C115.613 22 107.209 26.7166 102.119 33.9372C108.695 38.6642 113.744 45.3804 116.387 53.2049C128.453 53.4549 138.724 61.103 142.961 71.8533Z",
    fill: "#FFCD1D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherDop);
export default __webpack_public_path__ + "static/media/weatherDop.3da673ad5db09c33eb031d768879e261.svg";
export { ForwardRef as ReactComponent };